import React, { useState } from 'react';
import translations from '../../../utils/language/translations.json';
import { useTranslation } from 'react-i18next';

const PaginationComponentGridSold = ({
  totalPages,
  currentPage,
  setCurrentPage,
}) => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.CardGrid[key][currentLang];

  const handleChangePage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="pagination-controls flex-h" style={{ display: "flex", justifyContent: "center" }}>
      {/* Previous Page */}
      <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
        {t('Previous')}
      </button>

      {/* Page Numbers */}
      {Array.from({ length: totalPages }, (_, index) => (
        <button
          key={index + 1}
          onClick={() => handleChangePage(index + 1)}
          className={currentPage === index + 1 ? "active" : ""}
        >
          {index + 1}
        </button>
      ))}

      {/* Next Page */}
      <button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
        {t('Next')}
      </button>
    </div>
  );
};

export default PaginationComponentGridSold;
